const getAppStoreLink = (source?: string) => {
  const baseUrl = "https://apps.apple.com/app/apple-store/id1619316571";
  if (!source) return baseUrl;
  return `${baseUrl}?pt=124271047&ct=${encodeURIComponent(source)}&mt=8`;
};

const getGooglePlayLink = (referralCode: string, source?: string) => {
  const installReferrer = new URLSearchParams({ invite_code: referralCode });
  if (source) installReferrer.set("utm_source", source);

  const url = new URL(
    "https://play.google.com/store/apps/details?id=com.sweatwallet"
  );
  // Setting the complete inner query as one outer value applies the encoding
  // layer expected by Google Play's Install Referrer API.
  url.searchParams.set("referrer", installReferrer.toString());
  return url.toString();
};

const PATHS = {
  token: "/token",
  wallet: "/wallet",
  home: "/",
  partners: "/partners",
  learn: "/learn",
  supportedChains: "/supported-chains",
  appstore: "https://apps.apple.com/us/app/sweat-wallet/id1619316571",
  googleplay: "https://play.google.com/store/apps/details?id=com.sweatwallet",
  x: "https://x.com/SweatEconomy",
  telegram: "https://t.me/SweatEconomyAnnouncements",
  telegram_discussions: "https://t.me/sweateconomy",
  discord: "https://discord.com/invite/sweateconomy",
  facebook: "https://www.facebook.com/sweateconomy",
  reddit: "https://www.reddit.com/r/Sweateconomy",
  instagram: "https://www.instagram.com/sweateconomy",
  blog: "/blog",
  tokenomics: "/token#tokenomics",
  // dao: "",
  whitepaper: "https://whitepaper.swe.at/",
  activeDayValue: "/active-day-value",
  privacyPolicy: "/privacy",
  termsAndConditions: "/tnc",
  growTerms: "/grow-terms",
  helpCenter: "https://help.swe.at/",
  bugBounty: "https://immunefi.com/bug-bounty/sweateconomy/information/",
  mediaKit: "/media-kit",
  security: "/security",
  emissionLink: "/token#emissions",
  about: "/token#tokenomics",
  more: "/whitepaper",
  coingeckoSweat: "https://www.coingecko.com/en/coins/sweat-economy",

  bookCall: "",
  downloadPartnershipDeck: "",
  getInTouch: "https://wkf.ms/3MMO2uw",

  rewards: "",

  pancakeTrade:
    "https://pancakeswap.finance/swap?outputCurrency=0x510Ad22d8C956dCC20f68932861f54A591001283",
};

export { PATHS, getAppStoreLink, getGooglePlayLink };
